import * as Yup from "yup";

/**
 * Shared validation schema fragments.
 * Import individual field schemas and compose them into your form-specific schemas.
 */

/** First name — required, max 30 characters */
export const firstNameSchema = Yup.string()
  .max(30, "First name must not exceed 30 characters")
  .required("First name is required");

/** Last name — required, max 30 characters */
export const lastNameSchema = Yup.string()
  .max(30, "Last name must not exceed 30 characters")
  .required("Last name is required");

/** Email — valid format, max 50 characters, required */
export const emailSchema = Yup.string()
  .email("Invalid email address")
  .max(50, "Email must not exceed 50 characters")
  .required("Email is required");

/**
 * Password — min 8, max 30, must contain uppercase, lowercase, number, special char, required.
 */
export const passwordSchema = Yup.string()
  .min(8, "Password must be at least 8 characters")
  .max(30, "Password must not exceed 30 characters")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/[0-9]/, "Password must contain at least one number")
  .matches(
    /[^a-zA-Z0-9]/,
    "Password must contain at least one special character",
  )
  .required("Password is required");

/** Confirm password — must match password field */
export const confirmPasswordSchema = Yup.string()
  .oneOf([Yup.ref("password"), null], "Passwords must match")
  .required("Confirm Password is required");
